import { AnimatePresence, motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Handle screen resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  // Overlay animation
  const overlayVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 0.5, transition: { duration: 0.3 } },
    exit: { opacity: 0, transition: { duration: 0.2 } }
  };

  // Mobile sidebar animation
  const mobileSidebarVariants = {
    hidden: { x: '-100%' },
    visible: { x: 0, transition: { type: "spring", damping: 25, stiffness: 500 } },
    exit: { x: '-100%', transition: { duration: 0.2 } }
  };

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      {/* Desktop sidebar */}
      {!isMobile && (
        <div className="h-screen sticky top-0 w-[240px] flex-shrink-0">
          <Sidebar />
        </div>
      )}

      {/* Mobile sidebar with overlay */}
      <AnimatePresence>
        {isMobile && showSidebar && (
          <>
            <motion.div
              className="fixed inset-0 z-30 bg-black"
              variants={overlayVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              onClick={() => setShowSidebar(false)}
            />
            <motion.div
              className="fixed inset-y-0 left-0 z-40 w-[240px]"
              variants={mobileSidebarVariants}
              initial="hidden"
              animate="visible"
              exit="hidden"
            >
              <Sidebar isMobile={true} toggleSidebar={toggleSidebar} />
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {/* Main content */}
      <div className="flex flex-col flex-1 overflow-hidden">
        <Header toggleSidebar={toggleSidebar} />
        <main className="flex-1 overflow-y-auto p-6">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className="container mx-auto"
          >
            {children}
          </motion.div>
        </main>
      </div>
    </div>
  );
};

export default Layout; 